import { Box, Spinner } from '@palmetto/palmetto-components';
import { ReactNode, useEffect, useRef } from 'react';

export const InfiniteScroll = ({
  fetchNextPage,
  isLoading,
  children,
  hasMore,
}: {
  fetchNextPage: () => void;
  isLoading: boolean;
  children: ReactNode;
  hasMore: boolean;
}) => {
  const loaderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isLoading) {
          fetchNextPage();
        }
      },
      { threshold: 0.1 },
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [isLoading, fetchNextPage]);

  return (
    <Box gap="sm">
      {children}
      {hasMore && (
        <Box ref={loaderRef} display="flex" justifyContent="center" alignItems="center">
          {isLoading && (
            <Box direction="row" childGap="sm" alignItems="center">
              <Spinner size="lg" /> Loading more items...
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};
